import { z } from "zod";

// Schema for base cookie settings
export const baseCookieSettingsSchema = z.object({
  allowAnalytics: z.boolean(),
  hasDismissed: z.boolean(),
  enableOptOutCcpa: z.boolean()
});

// Schema for region-specific cookie settings
export const regionCookieSettingsSchema = baseCookieSettingsSchema
  .extend({
    _settingsEffectiveRegion: z.string()
  })
  .passthrough(); // Allow extra properties

export type CookieSettings = z.infer<typeof baseCookieSettingsSchema>;
export type RegionCookieSettings = z.infer<typeof regionCookieSettingsSchema>;
